export default __webpack_public_path__ + "static/media/img8.d99e2238.png";